import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Modal,
  UncontrolledDropdown,
} from "reactstrap";
import { useRecoilState } from "recoil";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { GET } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { popupPNCustomerFlowAtom, popupPNTransactionHistoryAtom } from "../../state";
import banks from '../../utils/banks';
import { bankHoookTransactionColTable } from "../../utils/col-table";
import { MONEY_TYPE } from "../../utils/Utils";
import PNExchangeMoneyBetweenAccounts from "./PNExchangeMoneyBetweenAccounts";


const MONEY_TYPE_OPTIONS = Object.keys(MONEY_TYPE).map((c) => ({
  label: MONEY_TYPE[c],
  value: c,
}));

const BANK_OPTIONS = banks.map((c) => ({
  label: c.shortName,
  value: c.code,
  data: c,
}));


const PNBankHookTransactions = () => {
  const [dataTemp, setData] = useState([]);

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [transferInternal, setTransferInternal] = useState({ IN: null, OUT: null });
  const [showTransferInternal, setShowTransferInternal] = useState(false);
  const [showExchange, setShowExchange] = useState(false);
  const [pnBankAccountOptions, setPNBankAccountOptions] = useState([]);
  const [popupPNCustomerFlow, setPopupPNCustomerFlow] = useRecoilState(popupPNCustomerFlowAtom);
  const [popupPNTransactionHistory, setPopupPNTransactionHistory] = useRecoilState(popupPNTransactionHistoryAtom);

  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams.get('startDate') || undefined).startOf('months').toDate(),
    endDate: moment(searchParams.get('endDate') || undefined).endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    type: searchParams.get('type') || undefined,
    bankCode: searchParams.get('bankCode') || undefined,
    bankNumber: searchParams.get('bankNumber') || undefined,
  });

  const data = useMemo(() => {
    return dataTemp.map(pnHookTransaction => {
      pnHookTransaction.bankAccount = pnBankAccountOptions.find(pnBankAccountOption => pnBankAccountOption?.data?.bankNumber === pnHookTransaction?.bankNumber)?.data;
      pnHookTransaction.lessAmount = (pnHookTransaction?.amount || 0) - (pnHookTransaction?.transactionHistoryTotal || 0)
      return pnHookTransaction;
    })
  }, [dataTemp, pnBankAccountOptions])
  const colTable = bankHoookTransactionColTable({
    actionCol: [
      ...(showTransferInternal ? [
        {
          Header: "Chuyển TK",
          accessor: (item) => <Input className="m-0 p-0" type="checkbox" checked={item.id === transferInternal[item.type]?.id} onClick={() => {
            setTransferInternal(transferInternal => ({
              ...transferInternal,
              [item.type]: item,
            }))
          }} />
        }
      ] : []),
      {
        Header: "Hành động",
        accessor: (item) => (
          <ul className="nk-tb-actions gx-1">
            <li>
              <UncontrolledDropdown>
                <DropdownToggle
                  tag="a"
                  className="btn btn-icon dropdown-toggle btn-trigger"
                >
                  <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                  <ul className="link-list-opt no-bdr">
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          history.push(`/pn/bank-hook-transactions/${item.id}`);
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Quản lý giao dịch nội bộ
                        </span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setPopupPNTransactionHistory({
                            show: true,
                            data: {
                              id: '',
                              type: item.type,
                              defaultValue: {
                                pnHookTransactionHistoryId: item.id,
                                content: item.content,
                                amount: item.lessAmount,
                                date: moment(item.createdAt).format('YYYY-MM-DD'),
                                ...(item.bankAccount ? {
                                  bankAccountId: item.bankAccount.id,
                                } : {})
                              }
                            }
                          })
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Thêm {MONEY_TYPE[item.type]}
                        </span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem
                        tag="a"
                        href="#edit"
                        onClick={(ev) => {
                          ev.preventDefault();
                          setPopupPNCustomerFlow({
                            show: true,
                            data: {
                              id: '',
                              type: item.type,
                              defaultValue: {
                                pnHookTransactionHistoryId: item.id,
                                content: item.content,
                                amount: item.lessAmount,
                                date: moment(item.createdAt).format('YYYY-MM-DD'),
                                ...(item.bankAccount ? {
                                  bankAccountId: item.bankAccount.id,
                                } : {})
                              }
                            }
                          })
                        }}
                      >
                        <Icon
                          name={"money"}
                        ></Icon>
                        <span>
                          Thêm {MONEY_TYPE[item.type]} NCC/KH
                        </span>
                      </DropdownItem>
                    </li>
                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown>
            </li>
          </ul>
        ),
      }
    ]
  })
  useEffect(() => {
    GET(`pn-bank-account`, {}, true).then((resp) => {
      setPNBankAccountOptions(
        resp.data.filter(e => !!e.bankNumber).map((c) => ({
          label: `${c.name}`,
          value: c.bankNumber,
          data: c,
        }))
      );
    });
  }, []);


  useEffect(() => {
    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.bankCode ? { bankCode: filter.bankCode } : {}),
      ...(filter.bankNumber ? { bankNumber: filter.bankNumber } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [timeNow, filter, popupPNCustomerFlow?.updatedAt, popupPNTransactionHistory?.updatedAt]);

  const getData = () => {
    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.type ? { type: filter.type } : {}),
      ...(filter.bankCode ? { bankCode: filter.bankCode } : {}),
      ...(filter.bankNumber ? { bankNumber: filter.bankNumber } : {}),
    };

    GET(`/pn-hook-transaction-history`, params, true)
      .then(({ data }) => {
        setData([...data.rows]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch nội bộ PN"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Quản lý giao dịch nội bộ PN</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap mw-200px">
                        <RSelect
                          placeholder={'Lọc theo TK'}
                          isClearable
                          options={pnBankAccountOptions}
                          value={pnBankAccountOptions.find((c) => c.value === filter.bankNumber)}
                          onChange={(val) => setFilter({
                            ...filter,
                            bankNumber: val?.value || undefined
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap mw-200px">
                        <RSelect
                          placeholder={'Lọc theo NH'}
                          isClearable
                          options={BANK_OPTIONS}
                          value={BANK_OPTIONS.find((c) => c.value === filter.bankCode)}
                          onChange={(val) => setFilter({
                            ...filter,
                            bankCode: val?.value || undefined
                          })}
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <RSelect
                          classNamePrefix="form-control"
                          isClearable
                          placeholder="Lọc loại tiền"
                          options={MONEY_TYPE_OPTIONS}
                          value={MONEY_TYPE_OPTIONS.find(
                            (c) => c.value === filter.type
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              type: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                      >

                        <Button className={'ml-2 btn-secondary'} onClick={() => {
                          setShowTransferInternal((showTransferInternal) => !showTransferInternal)
                          setTransferInternal({
                            IN: null,
                            OUT: null
                          })
                        }}>{showTransferInternal ? 'Ẩn chuyển TK khác' : 'Chuyển TK Khác'}</Button>
                      </div>
                    </li>
                    {
                      showTransferInternal && <li>
                        <div
                          className="form-control-wrap"
                        >
                          <Button
                            disabled={!transferInternal.IN || !transferInternal.OUT}
                            className={'ml-2  btn-primary'} onClick={() => {
                              if (transferInternal.IN.amount !== transferInternal.OUT.amount) {
                                toast.error('Vui lòng chọn giao dịch có số tiền trùng khớp')
                                return;
                              }
                              setShowExchange(true);
                            }}>Thực hiện chuyển TK Khác</Button>
                        </div>
                      </li>
                    }

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="my-3">
                  <Table
                    notShowPagi
                    loading={loading}
                    columns={colTable}
                    data={data}
                    conditionHighlightRow={(item) => item.amount !== item.transactionHistoryTotal ? 'font-weight-bold text-danger' : ''}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={showExchange}
          toggle={() => setShowExchange(false)}
          className="modal-dialog-centered"
          size="lg"
        >
          {showExchange && <PNExchangeMoneyBetweenAccounts
            pnBankAccountOptions={pnBankAccountOptions.map(c => ({
              label: c.data.name,
              value: c.data.id,
              data: c.data,
            }))}
            defaultValue={{
              content: transferInternal.IN?.content,
              amount: transferInternal.IN?.amount,
              date: moment(transferInternal.IN?.createdAt).format('YYYY-MM-DD'),
              pnHookInTransactionHistoryId: transferInternal.IN?.id,
              pnHookOutTransactionHistoryId: transferInternal.OUT?.id,
              ...(transferInternal.OUT?.bankAccount ? {
                fromBankAccountId: transferInternal.OUT.bankAccount.id,
              } : {}),
              ...(transferInternal.IN?.bankAccount ? {
                toBankAccountId: transferInternal.IN.bankAccount.id,
              } : {}),
            }}
            onClose={() => {
              setShowExchange(false);
              setTransferInternal({ IN: null, OUT: null });
              setTimeNow(moment().valueOf());
            }}
          />}
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default PNBankHookTransactions;
